import {
  TextInput,
  required,
  useTranslate,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";

import { makeStyles, Theme } from "@material-ui/core/styles";
import { Styles } from "@material-ui/styles/withStyles";
import { Typography } from "@material-ui/core";
import {
  MediaInputField,
} from "../../../lib/components";
import { RESOURCE_NAME_BUSINESS_FUNCTIONS } from "./constants";
import { MAX_RECORDS_PER_PAGE } from "../../../lib/common";

export const styles: Styles<Theme, any> = {
  name: { display: "block" },
  description: { display: "block" },
  account: { display: "block" },
};

const useStyles = makeStyles(styles);

const BusinessFunctionForm = ({ isEdit = false, ...rest }) => {
  const classes = useStyles(rest);
  return (
    <SimpleForm warnWhenUnsavedChanges {...rest}>
      <SectionTitle label="resources.businessFunction.fieldGroups.businessFunctionDetails" />
      <TextInput
        source="number"
        label="resources.businessFunction.fields.number"
        helperText="resources.businessFunction.help.number"
        formClassName={classes.name}
        autoFocus
        validate={[required()]}
      />
      <TextInput
        source="name"
        label="resources.businessFunction.fields.name"
        helperText="resources.businessFunction.help.name"
        formClassName={classes.name}
        validate={[required()]}
      />

      <RichTextInput
        source="description"
        label="resources.businessFunction.fields.description"
        helperText="resources.businessFunction.help.description"
        formClassName={classes.description}
      />

      <ReferenceInput
        source="parentId"
        label="resources.businessFunction.fields.parentId"
        reference={RESOURCE_NAME_BUSINESS_FUNCTIONS}
        perPage={MAX_RECORDS_PER_PAGE}
        sort={{ field: "name", order: "ASC" }}
        filter={isEdit ? { excludeIds: [rest?.id] } : {}}
        key="parentId"
        fullWidth
      >
        <AutocompleteInput
          optionText="displayLabel"
          resettable={true}
          allowEmpty={false}
          helperText="resources.businessFunction.help.parentId"
        />
      </ReferenceInput>

      <MediaInputField showUploadedFiles={isEdit} />
    </SimpleForm>
  );
};
const SectionTitle = ({ label }: { label: string }) => {
  const translate = useTranslate();

  return (
    <Typography variant="h6" gutterBottom>
      {translate(label)}
    </Typography>
  );
};

export { BusinessFunctionForm };
